module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-page"
  }, [_c('common-bar-container', {
    on: {
      "login": _vm.auth,
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('article-container', {
    staticClass: "article-container",
    on: {
      "auth": function($event) {
        _vm.$emit('auth', arguments[0])
      }
    }
  }), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68b74694"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Article.vue
// module id = 1013
// module chunks = 1